module.exports = __webpack_public_path__ + "img/ditie.85202ae4.png";